import {
  TOGGLE_VISIBILITY_EDIT_SELECTION,
  TOGGLE_VISIBILITY_JUMP_TO_PICK_NR,
  TOGGLE_VISIBILITY_EDIT_DRIVES,
  TOGGLE_VISIBILITY_EDIT_PICKS,
  TOGGLE_VISIBILITY_INFO
} from "./constants";

export default {
  [TOGGLE_VISIBILITY_EDIT_SELECTION](state) {
    state.showEditSelection = !state.showEditSelection;
  },
  [TOGGLE_VISIBILITY_JUMP_TO_PICK_NR](state) {
    state.showJumpToPickNr = !state.showJumpToPickNr;
  },
  [TOGGLE_VISIBILITY_EDIT_DRIVES](state) {
    state.showEditDrives = !state.showEditDrives;
  },
  [TOGGLE_VISIBILITY_EDIT_PICKS](state) {
    state.showEditPicks = !state.showEditPicks;
  },
  [TOGGLE_VISIBILITY_INFO](state) {
    state.showInfoComponent = !state.showInfoComponent;
  }
};
